import type { WebchatTranslations } from '.'

export const es: WebchatTranslations = {
  'composer.placeholder': 'Escribe tu mensaje...',
  'composer.sendButton.ariaLabel': 'Botón Enviar mensaje',
  'composer.voiceButton.ariaLabel': 'Botón Entrada de voz',
  'composer.fileButton.ariaLabel': 'Botón Subir archivo',
  'composer.messageInput.ariaLabel': 'Entrada de mensaje',

  'fileAttachment.uploadError': 'Error de carga',
  'fileAttachment.fallbackExtension': 'Archivo',
  'fileAttachment.removeButton.ariaLabel': 'Botón Eliminar archivo',

  'header.defaultBotName': 'Bot',
  'header.expandButton.ariaLabel': 'Botón Expandir encabezado',
  'header.sound.enable': 'Activar sonidos del chat',
  'header.sound.disable': 'Desactivar sonidos del chat',

  'conversationHistory.title': 'Conversaciones',
  'conversationHistory.empty': 'Aún no se ha iniciado ninguna conversación',
  'conversationHistory.newConversation': 'Nueva conversación',
  'conversationHistory.sentAttachment': 'Envió un archivo adjunto',
  'conversationHistory.showButton.ariaLabel': 'Botón Mostrar conversaciones recientes',

  'restartConversation.title': 'Crear nueva conversación',
  'restartConversation.description': 'Esto borrará la conversación actual y comenzará una nueva.',
  'restartConversation.confirm': 'Nueva conversación',
  'restartConversation.cancel': 'Cancelar',
  'restartConversation.button.ariaLabel': 'Botón Reiniciar conversación',

  'closeButton.ariaLabel': 'Botón Cerrar chatbot',

  'feedback.title': 'Ayúdanos a mejorar',
  'feedback.description': 'Por favor, envíanos tus comentarios para ayudarnos a mejorar.',
  'feedback.confirm': 'Enviar comentario',
  'feedback.cancel': 'Cancelar',
  'feedback.placeholder': 'Cuéntanos qué salió mal...',

  'error.configuration': 'Error de configuración',
  'error.bot': 'Error del bot',
  'error.network': 'Error de red',
  'error.disconnected': 'Desconectado',
  'error.unexpected': 'Error inesperado',

  'dropdown.placeholder': 'Seleccionar...',
}
